import { DBConnection, ROTransaction, RWTransaction } from './db'

class MockedTransaction implements RWTransaction {
  async commit(): Promise<void> {
    // do nothing
  }
  async rollback(): Promise<void> {
    // do nothing
  }
  onError?: ((reason: unknown) => void) | undefined
  async close(): Promise<void> {
    // do nothing
  }
}

export class MockedDBConnection implements DBConnection {
  name = 'mocked'
  async startROTransaction(): Promise<ROTransaction> {
    return new MockedTransaction()
  }
  async startRWTransaction(): Promise<RWTransaction> {
    return new MockedTransaction()
  }
  async close(): Promise<void> {
    // do nothing
  }
}
